export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10775.79f44e0e.jpg";